<template>
  <div class="userInfo">
    <div class="content"
         v-loading="loading">
      <div class="user-box">
        <div class="box1">
          <div style="width: 100%;display: flex;align-items: center;padding: 0 20px;box-sizing: border-box;">
            <div class="avatar"><img :src="!userInfo.headPortrait?'/images/default_avatar.png':userInfo.headPortrait"
                   alt=""></div>
            <div class="box1-right">
              <span class="name">{{ userInfo.nickName }}</span>
              <span class="phone">{{ userInfo.phone }}</span>
              <div @click="showModal = true"
                   style="display: flex;justify-content: flex-end;">
                <i class="el-icon-edit"></i>
              </div>
            </div>
          </div>
          <div class="company">单位：{{ userInfo.companyName }}</div>
        </div>
        <div class="box2"
             @click="jumpCard">
          <div class="box2_1">
            <div class="word">待兑换-卡包</div>
          </div>
        </div>
        <div class="box2"
             @click="jumpRecord">
          <div class="box2_2">
            <div class="word">兑换记录</div>
          </div>
        </div>
        <div class="box3">
          <div class="item">
            <div class="word">
              <span>福利卡余额：</span>
              <span style="width: 100px;display: inline-block;text-align: left;">{{ !userInfo.welfarePoint?0.00:userInfo.welfarePoint }}</span>
            </div>
          </div>
          <div class="item">
            <div class="word">
              <span>助农卡余额：</span>
              <span style="width: 100px;display: inline-block;text-align: left;"> {{ !userInfo.assistancePoint?0.00:userInfo.assistancePoint }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="box2">
          <div class="item">
            <span class="num">{{ !userInfo.welfarePoint?0.00:userInfo.welfarePoint }}</span>
            <span class="word">福利卡余额</span>
          </div>
          <div class="line"></div>
          <div class="item">
            <span class="num">{{ !userInfo.assistancePoint?0.00:userInfo.assistancePoint }}</span>
            <span class="word">助农卡余额</span>
          </div>
        </div> -->
      </div>
      <div class="order-box">
        <div class="title">我的订单</div>
        <div class="order-list">
          <div class="item"
               @click="jumpOrder(1)">
            <img src="/images/order_icon1.png"
                 alt="">
            <span>全部</span>
          </div>
          <div class="item"
               @click="jumpOrder(2)">
            <img src="/images/order_icon2.png"
                 alt="">
            <span>待付款</span>
          </div>
          <div class="item"
               @click="jumpOrder(3)">
            <img src="/images/order_icon3.png"
                 alt="">
            <span>待发货</span>
          </div>
          <div class="item"
               @click="jumpOrder(4)">
            <img src="/images/order_icon4.png"
                 alt="">
            <span>待收货</span>
          </div>
          <div class="item"
               @click="jumpOrder(5)">
            <img src="/images/order_icon5.png"
                 alt="">
            <span>已完成</span>
          </div>
          <div class="item"
               @click="jumpRefund">
            <img src="/images/order_icon6.png"
                 alt="">
            <span>退款/售后</span>
          </div>
        </div>
      </div>
      <div class="goods-box">
        <div class="like-box">
          <div class="line"></div>
          <span class="title">猜你喜欢</span>
          <div class="line"></div>
        </div>
        <div class="goods-list">
          <ul class="list1">
            <li class="goods_box"
                v-for="(item, index) in goodsList"
                :key="index"
                @click="jumpDetail(item)">
              <div class="item">
                <img :src="item.picUrl"
                     alt="">
                <div class="info">
                  <div class="name">{{ item.name }}</div>
                  <div class="num">已售{{ item.salesCount }}</div>
                  <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                </div>
              </div>
            </li>
          </ul>
          <div style="width: 100%;height: 300px;display: flex;justify-content: center;align-items: center;margin-top: 20px;"
               v-if="goodsList.length == 0">
            <el-empty description=" "></el-empty>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 40px;">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           background
                           :current-page="pageNum"
                           :page-size="pageSize"
                           layout="total, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改信息 -->
    <modal title="修改个人信息"
           btnType="1"
           :showModal="showModal"
           @cancel="closeModal"
           @submit="saveUserInfo">
      <template #body>
        <div class="edit-wrap"
             v-loading="modalLoading">
          <div class="mode-item">
            <span>头像：</span>
            <el-upload class="avatar-uploader"
                       action="https://shop.crcchc.com/api/api/file/upload"
                       :headers="headers"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess"
                       :before-upload="beforeAvatarUpload"
                       :limit="1">
              <div class="add">
                <img v-if="avatarUrl"
                     :src="avatarUrl"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </div>
          <div class="mode-item">
            <span>昵称：</span>
            <input type="text"
                   class="input"
                   maxlength="8"
                   placeholder="昵称"
                   v-model="nickName" />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal';
import { mapState } from 'vuex';
export default {
  name: 'userInfo',
  components: {
    Modal
  },
  data () {
    return {
      showModal: false,
      loading: false,
      modalLoading: false,
      nickName: '',
      avatarUrl: '',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('wckj-Token')
      },
      userInfo: {},
      goodsList: [],
      pageNum: 1,
      pageSize: 18,
      total: 0
    };
  },
  mounted () {
    this.$store.dispatch('savePersonType', 5)
    this.loading = true
    this.getUserInfo()
    this.getGoodsList()
  },
  computed: {
    ...mapState(['themeColor'])
  },
  methods: {
    // 跳转卡包
    jumpCard () {
      // this.$store.dispatch('savePersonType', 12)
      this.$router.push('/cardBag');
    },
    // 跳转兑换记录
    jumpRecord () {
      this.$router.push('/exchangeRecord');
    },
    // 跳转商品详情
    jumpDetail (item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.productType == 1) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "jdDetail",
        });
      }else if (item.productType == 2) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$router.push({
          name: "cakeDetail",
        });
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', type)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      }
    },
    // 跳转订单
    jumpOrder (type) {
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', type)
      this.$router.push('/orderList');
    },
    // 跳转售后订单
    jumpRefund(){
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', 16)
      this.$router.push('/refundOrderList');
    },
    // 关闭弹框
    closeModal () {
      this.showModal = false
      this.avatarUrl = ''
      this.nickName = ''
    },
    handleAvatarSuccess (res, file) {
      if (res.code == 200) {
        this.avatarUrl = file.response.data.url;
        this.modalLoading = false
      } else if (res.code == 500) {
        this.$message.warning(res.msg)
        this.modalLoading = false
      } else if (res.code == 401) {
        this.modalLoading = false
        this.$router.push('/login')
      }

    },
    beforeAvatarUpload (file) {
      this.modalLoading = true
    },
    // 保存个人信息
    saveUserInfo () {
      this.showModal = false
      this.loading = true
      this.$api.mall.changeInfo({
        nickName: this.nickName,
        wxHead: this.avatarUrl
      }).then((res) => {
        console.log(res, '保存个人信息');
        if (res.code == 200) {
          this.$message.success('保存成功');
          this.getUserInfo()
        }
        this.loading = false
      });
    },
    // 获取个人信息
    getUserInfo () {
      this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
          this.avatarUrl = res.data.userInfo.headPortrait
          this.nickName = res.data.userInfo.nickName
        }
      });
    },
    // 获取猜你喜欢
    getGoodsList () {
      this.$api.mall.getIndexGroupProduct({
        id: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        console.log(res, '商品列表');
        if (res.code == 200) {
          this.goodsList = !res.data.rows ? [] : res.data.rows
          this.total = !res.data.total ? 0 : res.data.total
        }
        this.loading = false
      });
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.loading = true
      this.getGoodsList(1)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.goodsList = []
      this.loading = true
      this.getGoodsList(1)
    },
  }
};
</script>
<style lang="scss" scoped>
.userInfo {
  width: 100%;
  min-height: 820px;
  .content {
    width: 100%;
    .user-box {
      width: 100%;
      background-color: #fff;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 300px;
        height: 220px;
        background-color: #004098;
        background: linear-gradient(to bottom, #ff3137, #ff6e37);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .avatar {
          width: 90px;
          height: 90px;
          border-radius: 100%;
          overflow: hidden;
          border: 5px solid #fff;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-items: center;
          img {
            width: 85px;
            height: 85px;
            display: block;
            border-radius: 100%;
          }
        }
        .box1-right {
          flex: 1;
          height: 90px;
          padding-left: 20px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #fff;
          .name {
            width: 100%;
            line-height: 30px;
            font-size: 16px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
          .phone {
            width: 100%;
            line-height: 30px;
            font-size: 14px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
          i {
            color: #fff;
            font-size: 20px;
          }
        }
        .company {
          width: 100%;
          height: 30px;
          background-color: rgba($color: #ffffff, $alpha: 0.4);
          margin-top: 20px;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
      }
      .box2 {
        width: 300px;
        height: 220px;
        display: flex;
        align-items: flex-end;
        .box2_1 {
          width: 100%;
          height: 220px;
          background-image: url("/images/card_icon1.png");
          background-repeat: no-repeat;
          background-size: 100% 220px;
          position: relative;
        }
        .box2_2 {
          width: 100%;
          height: 218px;
          background-image: url("/images/card_icon2.png");
          background-repeat: no-repeat;
          background-size: 100% 220px;
          position: relative;
        }
        .word {
          width: 100%;
          height: 18px;
          text-align: center;
          line-height: 18px;
          font-size: 12px;
          color: #ff0000;
          position: absolute;
          bottom: 18px;
          left: 0;
          z-index: 2;
        }
      }
      .box3 {
        width: 300px;
        height: 220px;
        background: linear-gradient(to bottom, #ff3137, #ff6e37);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .item {
          width: 100%;
          height: 40px;
          background-color: rgba($color: #ffffff, $alpha: 0.4);
          margin: 10px 0;
          padding: 0 20px;
          box-sizing: border-box;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }
      // .box2 {
      //   flex: 1;
      //   height: 170px;
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      //   .line {
      //     width: 1px;
      //     height: 81px;
      //     background-color: #ccc;
      //   }
      //   .item {
      //     flex: 1;
      //     height: 170px;
      //     display: flex;
      //     flex-direction: column;
      //     justify-content: center;
      //     align-items: center;
      //     .num {
      //       font-size: 26px;
      //       color: #e60012;
      //     }
      //     .word {
      //       font-size: 14px;
      //       color: #999999;
      //       margin-top: 10px;
      //     }
      //   }
      // }
    }
    .order-box {
      width: 100%;
      background-color: #fff;
      margin-top: 15px;
      .title {
        width: 100%;
        height: 50px;
        padding: 0 20px;
        box-sizing: border-box;
        line-height: 50px;
        font-size: 14px;
        border-bottom: 1px solid #dddddd;
      }
      .order-list {
        width: 100%;
        height: 115px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 46px;
            height: 46px;
            display: block;
          }
          .title {
            font-size: 14px;
            color: #4c4948;
          }
        }
      }
    }
    .goods-box {
      width: 100%;
      background-color: #fff;
      margin-top: 15px;
      .like-box {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        .line {
          width: 80px;
          height: 1px;
          background-color: #f5f5f5;
        }
        span {
          font-size: 18px;
          font-weight: bold;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
      .goods-list {
        width: 100%;
        padding: 0 25px 30px;
        box-sizing: border-box;
        .list1 {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-content: flex-start;
          flex-wrap: wrap;
          padding-left: 0;
          .goods_box {
            width: 195px;
            display: flex;
            justify-content: center;
            margin: 0 15px 20px 0;
            .item {
              width: 195px;
              border-radius: 4px;
              background-color: #f5f5f5;
              box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.05);

              img {
                width: 195px;
                height: 195px;
                border-radius: 8px 8px 0 0;
              }
              .info {
                width: 195px;
                height: 88px;
                background-color: #f5f5f5;
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-radius: 0 0 8px 8px;
                .name {
                  width: 100%;
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  word-break: break-all;
                }
                .num {
                  width: 100%;
                  text-align: center;
                  font-size: 12px;
                  color: #999999;
                }
                .price {
                  width: 100%;
                  font-size: 16px;
                  color: #e60012;
                  text-align: center;
                  span {
                    font-size: 10px;
                  }
                }
              }
            }
          }
          .goods_box:nth-child(6n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .edit-wrap {
    font-size: 14px;
    .mode-item {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      .input {
        display: inline-block;
        width: 400px;
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        border: 1px solid #e5e5e5;
        margin-right: 14px;
        & + .input {
          margin-left: 14px;
        }
      }
      .add {
        width: 100px;
        height: 100px;
        border: 1px dashed #ccc;
        box-sizing: border-box;
        border-radius: 4px;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .avatar {
        width: 100px;
        height: 100px;
        display: block;
        border-radius: 4px;
      }
    }
  }
}
</style>